import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getPersonById, sendTip, shareCase } from '../services/api';

const getStatus = (status, gender) => {
  const m = gender === 'Masculino';
  const cfg = {
    URGENTE:      { bg: '#FF2D2D', label: 'URGENTE' },
    DESAPARECIDA: { bg: '#FF8C00', label: m ? 'DESAPARECIDO' : 'DESAPARECIDA' },
    ENCONTRADA:   { bg: '#00C853', label: m ? 'ENCONTRADO' : 'ENCONTRADA' },
  };
  return cfg[status] || cfg.DESAPARECIDA;
};

export default function DetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [person, setPerson] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tipName, setTipName] = useState('');
  const [tipMsg, setTipMsg] = useState('');
  const [tipSent, setTipSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    getPersonById(id).then(setPerson).catch(() => navigate('/casos')).finally(() => setLoading(false));
  }, [id, navigate]);

  const FRONTEND = window.location.origin;
  const getShareUrl = () => `${FRONTEND}/caso/${id}`;
  const getShareText = () => person ? `Busqueda: ${person.name} desaparecido/a. Llama al 9-1-1 o contacta: ${person.contact}` : '';

  const shareWhatsApp = () => { shareCase(id).catch(()=>{}); window.open(`https://wa.me/?text=${encodeURIComponent(getShareText()+'\n'+getShareUrl())}`, '_blank'); };
  const shareFacebook = () => { shareCase(id).catch(()=>{}); window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(getShareUrl())}`, '_blank'); };
  const shareTwitter  = () => { shareCase(id).catch(()=>{}); window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(getShareText())}&url=${encodeURIComponent(getShareUrl())}`, '_blank'); };
  const shareInstagram = () => { copyLink(); alert('Enlace copiado. Pegalo en Instagram.'); };

  const copyLink = async () => {
    try { await navigator.clipboard.writeText(getShareUrl()); }
    catch { const t = document.createElement('textarea'); t.value = getShareUrl(); document.body.appendChild(t); t.select(); document.execCommand('copy'); document.body.removeChild(t); }
    setCopied(true); setTimeout(() => setCopied(false), 2500);
  };

  const handleTip = async (e) => {
    e.preventDefault();
    if (!tipMsg.trim()) return;
    setSending(true);
    try { await sendTip({ personId: id, reporterName: tipName || 'Anonimo', message: tipMsg }); setTipSent(true); } catch {}
    setSending(false);
  };

  const handleShare = async () => {
    await shareCase(id).catch(()=>{});
    if (navigator.share) { navigator.share({ title: person.name, text: getShareText(), url: getShareUrl() }); }
    else { copyLink(); }
  };

  if (loading) return <div style={{ textAlign:'center', padding:80, color:'#555' }}>Cargando...</div>;
  if (!person) return null;

  const cfg = getStatus(person.status, person.gender);

  const formatTime = (days) => {
    if (days < 30) return `${days} dia${days !== 1 ? 's' : ''}`;
    if (days < 365) {
      const m = Math.floor(days / 30);
      const d = days % 30;
      return d > 0 ? `${m} mes${m !== 1 ? 'es' : ''} y ${d} dia${d !== 1 ? 's' : ''}` : `${m} mes${m !== 1 ? 'es' : ''}`;
    }
    const y = Math.floor(days / 365);
    const m = Math.floor((days % 365) / 30);
    const d = days % 30;
    let result = `${y} año${y !== 1 ? 's' : ''}`;
    if (m > 0) result += `, ${m} mes${m !== 1 ? 'es' : ''}`;
    if (d > 0) result += ` y ${d} dia${d !== 1 ? 's' : ''}`;
    return result;
  };
  const ageCat = person.age < 18 ? 'Menor de edad' : person.age >= 65 ? 'Adulto mayor' : 'Adulto';
  const infoBlocks = [
    ['Edad', `${person.age} años - ${ageCat}`],
    ['Genero', person.gender],
    ['Ultima ubicacion', person.location || ''],
    ['Fecha', [person.lastSeen, person.lastSeenTime].filter(Boolean).join(' ')],
    ['Descripcion', person.description],
    ['Contacto', [person.contactName, person.contact].filter(Boolean).join(' - ')],
  ].filter(([,v]) => v);
  return (
    <div style={{ maxWidth:860, margin:'0 auto', padding: '20px 16px 80px' }}>
      <button onClick={() => navigate(-1)} style={{ background:'none', border:'none', color:'#FF8C00', fontSize:14, fontWeight:700, cursor:'pointer', marginBottom:16, padding:0 }}>
        Volver
      </button>
      <div className="detail-grid">
        <div>
          <div style={{ borderRadius:14, overflow:'hidden', height: 'auto', background:'#1A0A2E', marginBottom:10 }}>
            {person.photoUrl
              ? <img src={person.photoUrl} alt={person.name} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
              : <div style={{ width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:56, fontWeight:800, color:'#7B93D4' }}>{person.name.split(' ').slice(0,2).map(n=>n[0]).join('')}</div>
            }
          </div>
          <p style={{ fontSize:12, color:'#555', textAlign:'center', marginBottom:10 }}>Compartido {person.shared || 0} veces</p>
          <div style={{ background:'rgba(255,255,255,0.04)', borderRadius:12, padding:12, border:'1px solid rgba(255,255,255,0.08)' }}>
            <p style={{ fontSize:11, color:'#555', textAlign:'center', marginBottom:10, fontWeight:700 }}>COMPARTIR ESTE CASO</p>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:8 }}>
              <button onClick={shareWhatsApp} style={{ padding:'10px', borderRadius:10, border:'none', background:'#25D366', color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer' }}>WhatsApp</button>
              <button onClick={shareFacebook} style={{ padding:'10px', borderRadius:10, border:'none', background:'#1877F2', color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer' }}>Facebook</button>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:8 }}>
              <button onClick={shareTwitter} style={{ padding:'10px', borderRadius:10, border:'none', background:'#000', color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer' }}>X / Twitter</button>
              <button onClick={shareInstagram} style={{ padding:'10px', borderRadius:10, border:'none', background:'linear-gradient(45deg,#f09433,#dc2743,#bc1888)', color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer' }}>Instagram</button>
            </div>
            <button onClick={copyLink} style={{ width:'100%', padding:'10px', borderRadius:10, border:'1px solid rgba(255,255,255,0.15)', background: copied ? 'rgba(0,200,83,0.15)' : 'rgba(255,255,255,0.06)', color: copied ? '#00C853' : '#ccc', fontSize:13, fontWeight:600, cursor:'pointer' }}>
              {copied ? 'Enlace copiado!' : 'Copiar enlace'}
            </button>
          </div>
        </div>
        <div>
          <span style={{ display:'inline-block', padding:'4px 12px', borderRadius:7, fontSize:11, fontWeight:800, background:cfg.bg+'33', color:cfg.bg, border:`1px solid ${cfg.bg}55`, marginBottom:10 }}>{cfg.label}</span>
          <h1 style={{ fontSize: 'clamp(20px,5vw,26px)', fontWeight:800, marginBottom:4, lineHeight:1.2, color:'#F0EDE8' }}>{person.name}</h1>
          <p style={{ fontSize:12, color:'#555', marginBottom:8 }}>CASO #{person.caseId}</p>
          {person.status !== 'ENCONTRADA' && person.daysActive > 0 && (
            <div style={{ background:'rgba(255,45,45,0.08)', border:'1px solid rgba(255,45,45,0.2)', borderRadius:12, padding:'10px 16px', marginBottom:12, display:'flex', alignItems:'baseline', gap:8 }}>
              <span style={{ fontSize:22, fontWeight:800, color:'#FF2D2D' }}>{formatTime(person.daysActive)} desaparecido/a</span>
            </div>
          )}
          {person.foundNote && (
            <div style={{ background:'rgba(0,200,83,0.08)', border:'1px solid rgba(0,200,83,0.2)', borderRadius:12, padding:'10px 16px', marginBottom:12 }}>
              <span style={{ color:'#00C853' }}>{person.foundNote}</span>
            </div>
          )}
          {infoBlocks.map(([label, value]) => (
            <div key={label} style={{ background:'rgba(255,255,255,0.04)', borderRadius:10, padding:'10px 14px', marginBottom:8, border:'1px solid rgba(255,255,255,0.07)' }}>
              <div style={{ fontSize:10, color:'#555', letterSpacing:1, marginBottom:4, fontWeight:700 }}>{label.toUpperCase()}</div>
              <div style={{ fontSize:14, color:'#F0EDE8', whiteSpace:'pre-line' }}>{value}</div>
            </div>
          ))}
          <a href={`tel:${person.contact}`} style={{ display:'block', textDecoration:'none', marginTop:10 }}>
            <button style={{ width:'100%', padding:'13px', background:'#FF2D2D', border:'none', borderRadius:12, color:'#fff', fontSize:15, fontWeight:700, cursor:'pointer' }}>Llamar: {person.contact}</button>
          </a>
          <button onClick={handleShare} style={{ width:'100%', padding:'11px', background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.14)', borderRadius:10, color:'#ccc', fontSize:14, fontWeight:600, cursor:'pointer', marginTop:8 }}>Compartir este caso</button>
          {person.status !== 'ENCONTRADA' && (
            <div style={{ marginTop:18, background:'rgba(255,45,45,0.06)', borderRadius:14, padding:16, border:'1px solid rgba(255,45,45,0.15)' }}>
              <h3 style={{ fontSize:12, fontWeight:700, color:'#888', letterSpacing:1.5, marginBottom:12 }}>ENVIAR PISTA ANONIMA</h3>
              {tipSent
                ? <div style={{ background:'rgba(0,200,83,0.08)', borderRadius:10, padding:12, color:'#00C853', fontWeight:700, textAlign:'center' }}>Pista enviada. Gracias.</div>
                : <form onSubmit={handleTip}>
                    <input style={{ width:'100%', padding:'10px 12px', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:8, color:'#F0EDE8', fontSize:13, marginBottom:8, outline:'none', boxSizing:'border-box' }} placeholder="Tu nombre (opcional)" value={tipName} onChange={e=>setTipName(e.target.value)} />
                    <textarea style={{ width:'100%', padding:'10px 12px', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:8, color:'#F0EDE8', fontSize:13, marginBottom:8, outline:'none', resize:'none', height:90, boxSizing:'border-box' }} placeholder="Describe lo que viste..." value={tipMsg} onChange={e=>setTipMsg(e.target.value)} required />
                    <button type="submit" disabled={sending} style={{ width:'100%', padding:'11px', background:'#FF2D2D', border:'none', borderRadius:8, color:'#fff', fontSize:14, fontWeight:700, cursor:sending?'not-allowed':'pointer' }}>{sending ? 'Enviando...' : 'Enviar pista'}</button>
                  </form>
              }
            </div>
          )}
        </div>
      </div>
      <div style={{ background:'rgba(255,45,45,0.08)', borderRadius:12, padding:14, border:'1px solid rgba(255,45,45,0.2)', textAlign:'center', marginTop:28 }}>
        <span style={{ color:'#FF8C8C', fontWeight:600 }}>Si ves a esta persona, llama al 9-1-1</span>
      </div>
    </div>
  );
}